import { z } from 'zod'

// this is the canonical way to express zod date times for omnea
export const DateTimeSchema = z.string().datetime({ offset: true })

export const DateTimeSchemaV4 = z.iso.datetime({ offset: true })
